'use strict';

import { body } from '@jspartials/general-utils';
import { createElement } from '@jspartials/dom-api-utils';

const addSpinner = (target) => {
  const extraClasses = target === body ? ['is-fixed'] : [];
  const spinner = createElement({
    tag: 'div',
    content: `
    <div class="hw-spinner__letter"></div>
    <div class="hw-spinner__ring">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  `,
    classes: ['hw-spinner', 'js-spinner']
  });
  const backgroundSpinner = createElement({
    tag: 'div',
    content: spinner,
    classes: ['hw-spinner-background', 'js-spinner-background', ...extraClasses]
  });

  target.appendChild(backgroundSpinner);
};

const removeSpinner = (target) => {
  if (target) {
    const spinnerBackgroundElement =
      target.querySelector('.js-spinner-background') || null;

    if (spinnerBackgroundElement) {
      spinnerBackgroundElement.remove();
    }
  }
};

const startSpinner = (selector) => {
  const targetElement = document.querySelector(selector) || body;

  addSpinner(targetElement);
};

const stopSpinner = (selector) => {
  const targetElement = document.querySelector(selector) || body;

  removeSpinner(targetElement);
};

// Export
export { startSpinner, stopSpinner };
